const validate = values => {
  const errors = {}

  if (!values?.first_name) {
    errors.first_name = "The first name is required"
  }

  if (!values?.last_name) {
    errors.last_name = "The last name is required"
  }

  if (!values?.email) {
    errors.email = "The email is required"
  }

  if (
    values?.email &&
    !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)
  ) {
    errors.email = "A valid email address is required"
  }

  if (!values?.password) {
    errors.password = "You must add a password"
  }

  if (!values?.confirm_password) {
    errors.confirm_password = "You must confirm the password"
  }

  if (values?.password && values?.confirm_password) {
    if (values?.password !== values?.confirm_password) {
      errors.confirm_password = "The passwords don't match"
    } else if (values?.confirm_password?.length < 8) {
      errors.confirm_password = "The password must be at least 8 characters."
    }
  }

  return errors
}

export default validate
